<template>
  <div class="section">
    <div class="section-content">
      <div v-if="products.length > 0 && curationInfo.length > 0"
           v-for="(c, index) in curationInfo"
           :key="'ab' + index">
        <div class="more-url"><a style="color: #383838;" v-bind:href="c.tci_more_url" target="_blank">更多 ></a></div>
        <div class="curation-banners">
          <div class="banner">
            <a v-bind:href="c.tci_url" target="_blank"><img :src="c.tci_pic" /></a>
          </div>
        </div>
      </div>
      <swiper v-bind:options="swiperOption" ref="list-swiper" class="list-swiper">
        <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in products"
            :key="'hot' + index">
          <div class="page">
            <loading :active.sync="isLoading" :is-full-page="false"></loading>
            <product-block v-bind="{ info: item, modifier: 'm' }" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import ProductBlock from '../ProductBlock.vue'

export default {
  name: 'ProductSlider',
  components: {
    ProductBlock,
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 2.5,
        spaceBetween: 16,
        loop: false,
      },
      products:[{
        tci_pic: '../../images/placholder_1200.svg',
        tci_url: '',
        tci_more_url: ''
      },
      {
        tci_pic: '../../images/placholder_1200.svg',
        tci_url: '',
        tci_more_url: ''
      },
      {
        tci_pic: '../../images/placholder_1200.svg',
        tci_url: '',
        tci_more_url: ''
      }],
      curationInfo: [],
      isLoading: true,
    }
  },
  methods: {
    getData () {
      axios.get('/ticket/api/product/list')
      .then((response) => {
        this.products = response.data.D;
        this.isLoading = false;
      })

      axios.get('/ticket/api/curation/info/list')
      .then((response) => {
        this.curationInfo = response.data.B;
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.swiper-container {
  background-color: #ffffff !important;
  border-radius:10px;
  padding: 16px !important;
  margin-top: -10% !important;
  margin-left: 4.8%;
  margin-right: 4.8%;
  overflow: scroll;
}
.more-url {
  margin-top: 50px;
  font-size: 12px;
  background-color: #ffffff;
  border-radius:12px;
  position: absolute;
  z-index:1;
  width: 50px;
  text-align: center;
  right: 8%;
  padding: 2px 4px;
}
.section ~ .section {
  border-top: 10px solid #f1f2f2;
  padding-bottom: 10px;
}
.more-link a {
  text-decoration: none;
  font-size: 0.8rem;
  color: gray;
}
.section-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 16px 16px;
}
.section-header {
  .icon {
    width: 94px;
    height: 24px;
    img {
      width: 100%;
    }
    .section-title {
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0.56px;
      color: #383838;
    }
  }
}
.touch-area {
  span {
    margin-right: 4px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.5);
  }
}
.list-swiper {
  padding: 0 1.2rem;
}
.swiper-container .swiper-slide {
  width: 7.2rem;
}
.swiper-container .swiper-slide img {
  width: 100%;
}
.curation-banners {
  padding: 20px 4.8%;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 0;
  .banner {
    font-size: 0;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    img {
      width: 100%;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      &.error-img {
        & + .error-holder {
          display: block;
        }
      }
    }
    .error-holder {
      display: none;
    }
  }
}
</style>
